// extracted by mini-css-extract-plugin
export var container = "_en-0";
export var icon = "_en-1";
export var text = "_en-2";